import { AppRoute } from '@core/route-data/models/app-routes';
import { LoginPageComponent } from '@pages/login/components/login-page/login-page.component';
import { PostLoginWorkflow } from '@core/sso/models/post-login-workflow.enum';
import { hasKaseyaStoreLoginAccessGuard } from '@pages/login/guards/has-kaseya-store-login-access.guard';

export const loginRoutes: AppRoute[] = [
  {
    path: '',
    component: LoginPageComponent,
  },
  {
    path: 'authorize',
    component: LoginPageComponent,
    data: {
      workflow: PostLoginWorkflow.OpenIdConnect,
    },
  },
  {
    path: 'jwt/vanilla-forums',
    component: LoginPageComponent,
    data: {
      workflow: PostLoginWorkflow.KaseyaCommunity,
    },
  },
  {
    path: 'jwt/kaseya-community',
    component: LoginPageComponent,
    data: {
      workflow: PostLoginWorkflow.KaseyaCommunity,
    },
  },
  {
    path: 'zendesk',
    component: LoginPageComponent,
    data: {
      workflow: PostLoginWorkflow.KaseyaZendeskLogin,
    },
  },
  {
    path: 'store',
    component: LoginPageComponent,
    canActivate: [hasKaseyaStoreLoginAccessGuard],
    data: {
      workflow: PostLoginWorkflow.KaseyaStore,
    },
  },
];
